import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AuthService } from '@core';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { MatButtonModule } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    NgClass,
    MatButtonModule,
  ],
})
export class SigninComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit
{
  loginForm!: UntypedFormGroup;
  submitted = false;
  error = '';
  hide = true;
  isLoading = false;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService
  ) {
    super();
  }
  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: [
        'admin@test.com',
        [Validators.required, Validators.email, Validators.minLength(5)],
      ],
      password: ['admin', Validators.required],
    });
  }

  get form(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    this.error = '';
    if (this.loginForm.invalid) {
      this.error = 'Veuillez saisir un email et un mot de passe valides pour continuer!';
      return;
    }

    // Prevent multiple submissions
    if (this.isLoading) {
      return;
    }

    // Disable form during request
    this.isLoading = true;
    this.loginForm.disable();

    this.subs.sink = this.authService
      .login({
        email: this.form['email'].value,
        password: this.form['password'].value,
      })
      .subscribe(
        () => {
          const token = this.authService.token;
          const role = this.authService.role;
          if (token && role && ['Admin', 'Operator'].includes(role)) {
            this.router.navigate(['/dashboard']);
          }
          // Keep form disabled on success since we're navigating away
        },
        (error) => {
          // Re-enable form on error
          this.isLoading = false;
          this.loginForm.enable();
          this.submitted = false;

          this.error = error;
          if(error.status == "401"){
            this.error = 'L\'email ou le mot de passe que vous avez saisi est incorrect. Veuillez réessayer!';
          }else{
            this.error = error.detail;
          }
        }
      );
  }
}
